export default {
    OKTA_PASSWORD_POLICIES_STATUS: "OKTA_PASSWORD_POLICIES_STATUS"
}